module.exports = __webpack_public_path__ + "img/mastercard.4dfe1b63.svg";